
export default {
    props: {
        currentStep: {
            type: Number,
            required: true,
        },
    },
}
